<template>
  <hm-content title="">
    <div class="">
      <div class="table-panel flex flex-between">
        <el-button size="small" @click="addGroup" type="primary"
          >新增分组</el-button
        >
        <div>
          <el-input
            class="mr10"
            size="small"
            v-model="searchConditions.groupName"
            placeholder="请输入分组名称"
          ></el-input>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table-wrapper">
        <el-table
          :data="groupList"
          style="width: 100%"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商品分组"
            prop="groupName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="relNum"
            label="商品数量"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间"
          ></el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-tooltip class="item" content="编辑" placement="top">
                  <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                    <span class="hmicon icon-bianji blue"></span>
                  </button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="top"
                  style="color: #E50065"
                >
                  <button class="pointer mr10 no-bg" @click="remove(scope.row)">
                    <span class="hmicon icon-shanchu blue"></span>
                  </button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="二维码"
                  placement="top"
                  style="color: #E50065"
                >
                  <button class="pointer mr10 no-bg" @click="productQrcode(scope.row)">
                    <span class="hmicon icon-erweima blue"></span>
                  </button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="groupListTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <el-form>
        <el-form-item label="分组名称">
          <el-input
            placeholder="请输入分组名称，限制20字"
            maxlength="20"
            v-model="groupName"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否赠品">
          <el-radio-group v-model="isGift">
            <el-radio label="yes">是</el-radio>
            <el-radio label="no">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选中指定仓库" v-if="isGift === 'yes'">
          <el-select v-model="depotId" placeholder="请选择仓库" size="small" clearable filterable>
            <el-option
              v-for="item in depotList.records"
              :key="item.depotId"
              :label="item.depotName"
              :value="item.depotId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分组水印">
          <div class="flex">
            <div class="import-btn open-file">
              <div
                class="upload-wrapper flex flex-column item-center flex-center"
                @click="uploadImg"
                v-if="!groupLabelPic"
              >
                <div class="add-wrapper">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span>上传水印</span>
              </div>
              <div class="img-wrapper" v-if="groupLabelPic">
                <div class="close-wrapper" @click="groupLabelPic = ''">
                  <span class="hmicon icon-jujue"></span>
                </div>
                <img :src="groupLabelPic" alt="" @click="uploadImg" />
              </div>
            </div>
            <div class="opreat-wrapper flex item-center flex-center" v-if="groupLabelPic">
              <el-button type="text" @click="removePic">删除图片</el-button>
            </div>
            <div class="form-tip opreat-wrapper flex item-center flex-center">水印尺寸建议750x750，请上传png格式</div>
          </div>
        </el-form-item>
      </el-form>
      <div class="mb10 flex flex-between">
        <div>
          <el-button
            size="small"
            type="primary"
            @click="filterGoodsDialogVisible = true"
            >添加商品</el-button
          >
        </div>
        <div>
          <el-input
              class="mr10"
              size="small"
              v-model="searchInfo"
              placeholder="请输入商品名称或货号"
          ></el-input>

        </div>
        <div class="flex flex-wrap item-center">
          <div @click="outputExcel" class="delete mr10 pointer">
            <span class="delete-icon hmicon icon-daochu"></span>
            导出模板
          </div>
          <div class="delete mr10 pointer open-file">
            <span class="delete-icon hmicon icon-daoru"></span>
            导入商品（货号）
            <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
          <div class="delete pointer open-file">
            <span class="delete-icon hmicon icon-daoru"></span>
            导入商品（条码）
            <input
              type="file"
              @change="importfBarcode"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
        </div>
      </div>
      <el-table
        :data="
        groupModelList.filter(
          (data) =>
          !searchInfo ||
          data.wxshopSpuName
          .toLowerCase()
          .includes(searchInfo.toLowerCase()) ||
          data.goodsSn
          .toLowerCase()
          .includes(searchInfo.toLowerCase())
        )"

        style="width: 100%"
        stripe
        border
        class="mb10"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="wxshopSpuName"
          label="商品名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsSn"
          label="货号"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="排序">
          <template slot-scope="scope">
            <el-input
              type="number"
              size="small"
              @mousewheel.prevent.native
              v-model="scope.row.seqNum"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="gameName"
          label="编辑"
        >
          <template slot-scope="scope">
            <el-button @click="removeRow(scope.$index)" type="text"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="请用微信扫一扫"
      :visible.sync="qrcodeDialogVisible"
      :modal="false"
      width="250px"
    >
      <div class="qrcode-wrapper">
        <img style="width: 100%" :src="activityCode" alt="二维码" />
      </div>
    </el-dialog>
    <hm-filter-micro-shop-goods-new
      type="microShop"
      :visible="filterGoodsDialogVisible"
      :radio="false"
      @saveGoods="saveGoods"
      @close="filterGoodsDialogVisible = false"
    ></hm-filter-micro-shop-goods-new>
    <my-upload
      field="file"
      @crop-upload-success="cropUploadSuccess"
      v-model="show"
      v-if="show"
      noCircle
      noSquare
      :width="750"
      :height="750"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsGroup' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误未导入
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column prop="goodsSn" label="错误货号">
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmFilterMicroShopGoodsNew from "@/components/HmFilterMicroShopGoodsNew";
import { arrayUnique2 } from "@/utils/utils";
import {getLoginUser, getUserName} from "@/utils/auth";
import myUpload from "vue-image-crop-upload";
import { mapGetters } from "vuex";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmFilterMicroShopGoodsNew,
    myUpload
  },
  data() {
    return {
      errValidGoods: false,
      errInputResult: [],
      show: false,
      filterGoodsDialogVisible: false,
      dialogVisible: false,
      groupName: "",
      groupModelList: [],
      searchConditions: {},
      currentPage: 1,
      pageSize: 10,
      mode: "",
      title: "",
      groupList: [],
      groupListTotal: 0,
      groupLabelPic: "",
      currentRow: {},
      searchInfo: "",
      activityCode: "",
      qrcodeDialogVisible: false,
      isGift: "no",
      depotId: ""
    };
  },
  computed: {
    ...mapGetters(["depotList"])
  },
  watch: {},
  created() {
    this.$store.dispatch("queryDepotListList", {
      pageNo: 1,
      pageSize: 999999
    });
    this.queryList();
  },
  mounted() {},
  methods: {
    removePic() {
      this.groupLabelPic = "";
    },
    async productQrcode(row) {
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      let params = {
          path: `pages/product/list?groupId=${row.groupId}`,
          storeCode: storeCode,
          createBy: userName,
          shareFunction: "店铺装修-商品分组",
          shareFrom: "bg"
        }
      const url = await this.$store.dispatch("shareDataSaveV2", params);
      let path = `pages/product/list?saveUUID=${url.result}`;

      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path
      });
      this.qrcodeDialogVisible = true;
      this.activityCode = result;
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号", "排序"];
        const data = [["ABC123", "1"]];

        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导入excel
    importfBarcode(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        // let isValid = true;
        // let isRequired = true;
        let goodsSns = [];
        result.forEach(v => {
          v[0] = v[0] ? (v[0] + "").replace(/\s*/g, "") : "";
          if (v[0] !== "") {
            formatResult.push({
              goodsSn: v[0],
              seqNum: v[1]
            });
          }
        });
        formatResult = arrayUnique2(formatResult, "goodsSn");
        goodsSns = formatResult.map(o => o.goodsSn);
        that.$store
          .dispatch("queryGoodsSnOffline", { goodsSns, importType: "barcode" })
          .then(res => {
            const { code, result } = res;
            if (code === "0") {
              if (result.notEffectiveGoods.length) {
                that.errValidGoods = true;
                that.errInputResult = result.notEffectiveGoods;
                that.$message({
                  message: "部分条码导入失败！",
                  type: "warning"
                });
              }
              let goodsSnList = result.effectiveGoods.map(o => o.goodsSn);
              if (result.effectiveGoods.length) {
                let params = {
                  pageSize: 99999,
                  pageNo: 1,
                  goodsSnList
                };
                that.$store
                  .dispatch("queryAllMicroShopGoodsList", params)
                  .then(res => {
                    that.groupModelList.push(...res.result.records);
                    that.groupModelList = arrayUnique2(
                      that.groupModelList,
                      "wxshopSpuId"
                    );
                    that.groupModelList.forEach(v => {
                      formatResult.forEach(j => {
                        if (v.goodsSn === j.goodsSn) {
                          v.seqNum = j.seqNum;
                        }
                      });
                    });
                  });
              }

              // result.effectiveGoods.forEach(v => {
              //   v.attrValue = v.goodsName;
              //   v.attrId = v.goodsSn;
              //   v.attrType = "goods";
              // });
              // that.leftData.push(...result.effectiveGoods);
              // that.leftData = arrayUnique2(that.leftData, "attrId");
              // that.leftData.forEach(v => {
              //   v.goodsPackageNum = 1;
              //   if (v.goodsName) {
              //     v.goodsInfo = v.goodsName;
              //   }
              // });
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        // let isValid = true;
        // let isRequired = true;
        let goodsSns = [];
        result.forEach(v => {
          v[0] = v[0] ? (v[0] + "").replace(/\s*/g, "") : "";
          if (v[0] !== "") {
            formatResult.push({
              goodsSn: v[0],
              seqNum: v[1]
            });
          }
        });
        formatResult = arrayUnique2(formatResult, "goodsSn");
        goodsSns = formatResult.map(o => o.goodsSn);
        that.$store
          .dispatch("queryGoodsSnOffline", { goodsSns, importType: "goods" })
          .then(res => {
            const { code, result } = res;
            if (code === "0") {
              if (result.notEffectiveGoods.length) {
                that.errValidGoods = true;
                that.errInputResult = result.notEffectiveGoods;
                that.$message({
                  message: "部分货号导入失败！",
                  type: "warning"
                });
              }
              let goodsSnList = result.effectiveGoods.map(o => o.goodsSn);
              if (result.effectiveGoods.length) {
                let params = {
                  pageSize: 99999,
                  pageNo: 1,
                  goodsSnList
                };
                that.$store
                  .dispatch("queryAllMicroShopGoodsList", params)
                  .then(res => {
                    that.groupModelList.push(...res.result.records);
                    that.groupModelList = arrayUnique2(
                      that.groupModelList,
                      "wxshopSpuId"
                    );
                    that.groupModelList.forEach(v => {
                      formatResult.forEach(j => {
                        if (v.goodsSn === j.goodsSn) {
                          v.seqNum = j.seqNum;
                        }
                      });
                    });
                  });
              }

              // result.effectiveGoods.forEach(v => {
              //   v.attrValue = v.goodsName;
              //   v.attrId = v.goodsSn;
              //   v.attrType = "goods";
              // });
              // that.leftData.push(...result.effectiveGoods);
              // that.leftData = arrayUnique2(that.leftData, "attrId");
              // that.leftData.forEach(v => {
              //   v.goodsPackageNum = 1;
              //   if (v.goodsName) {
              //     v.goodsInfo = v.goodsName;
              //   }
              // });
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    cropUploadSuccess(jsonData) {
      this.groupLabelPic = jsonData.result;
    },
    saveGoods(row) {
      this.filterGoodsDialogVisible = false;

      this.groupModelList.push(...row);
      this.groupModelList = arrayUnique2(this.groupModelList, "wxshopSpuId");
    },
    pickGoods() {},
    addGroup() {
      this.mode = "add";
      this.title = "新增分组";
      this.dialogVisible = true;
      this.groupName = "";
      this.groupLabelPic = "";
      this.groupModelList = [];
      this.isGift = "no";
      this.depotId = "";
    },
    async edit(row) {
      this.mode = "edit";
      this.title = "编辑分组";
      this.currentRow = row;
      this.dialogVisible = true;
      this.groupName = row.groupName;
      this.groupLabelPic = row.groupLabelPic;
      this.isGift = row.isGift || "no";
      this.depotId = row.depotId || "";
      const { result } = await this.$store.dispatch("queryGoodsGropDetails", {
        groupId: row.groupId
      });
      this.groupModelList = result;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryGoodsGroupList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        groupName: this.searchConditions.groupName
      });
      const { records, total } = result;
      this.groupList = records;
      this.groupListTotal = total;
    },
    async save() {
      if (!this.groupName) {
        this.$message({
          type: "warning",
          message: "请输入分组名称"
        });
      } else if (!this.groupModelList.length) {
        this.$message({
          type: "warning",
          message: "请先添加商品"
        });
      } else if (this.isGift === "yes" && !this.depotId) {
        this.$message({
          type: "warning",
          message: "请选择仓库"
        });
      } else {
        let actionName = "";
        let params = {
          groupModelList: this.groupModelList,
          groupName: this.groupName,
          groupLabelPic: this.groupLabelPic,
          isGift: this.isGift,
          depotId: this.depotId
        };
        if (this.mode === "add") {
          actionName = "addGoodsGroup";
        } else {
          actionName = "editGoodsGroup";
          Object.assign(params, {
            groupId: this.currentRow.groupId
          });
        }
        const { code } = await this.$store.dispatch(actionName, params);
        if (code === "0") {
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.dialogVisible = false;
          this.queryList();
        }
      }
    },
    removeRow(i) {
      this.groupModelList.splice(i, 1);
    },
    uploadImg() {
      this.show = true;
    },
    async remove(row) {
      const result = await this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("deleteGoodsGrop", {
          groupId: row.groupId
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryList();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.import-btn {
  position: relative;
  border: 1px dashed #ddd;
  text-align: center;
  width: 102px;
  height: 102px;
  box-sizing: border-box;
  text-align: center;
  margin-right: 10px;
  cursor: pointer;
  .upload-wrapper {
    height: 100%;
  }
  .close-wrapper {
    position: absolute;
    top: -20px;
    right: -10px;
    z-index: 100;
    .hmicon {
      font-size: 20px;
    }
  }
  .img-wrapper {
    img {
      width: 100%;
    }
  }
  .add-wrapper {
    margin: 0 auto;
  }
}
</style>
